import PropTypes from 'prop-types';

import Viewer360 from '@spotahome/marketplace-common/src/LEGACY/javascripts/show-rentable-unit/components/viewer-360';

import {
  on360Load,
  on360ChangeScene,
  on360FullScreenOn,
  on360FullScreenOff
} from '../../utils/360Events';

import { Consumer } from './utils/viewer360Context';

const SliderTrackViewer360 = props => (
  <Consumer>
    {({ isLandscape }) => (
      <Viewer360
        photos={props.item.photos}
        onLoad={on360Load}
        onChangeScene={on360ChangeScene}
        onFullScreenOn={on360FullScreenOn}
        onFullScreenOff={on360FullScreenOff}
        isLandscape={isLandscape}
      />
    )}
  </Consumer>
);

SliderTrackViewer360.propTypes = {
  item: PropTypes.shape({
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        caption: PropTypes.string,
        src: PropTypes.shape({
          small360: PropTypes.string,
          large360: PropTypes.string
        })
      })
    )
  }).isRequired
};

export default SliderTrackViewer360;
